import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top on every pathname change.
 *
 * React Router v6 preserves scroll across route transitions by default,
 * which feels broken when navigating from a long list (Exercises) into
 * a detail page — users land mid-page. Mount this once near the top of
 * the router tree and it scrolls to 0 whenever the URL path changes.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
